import React, { useState, useEffect, Fragment, useRef } from "react";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../utils/AppInsights";
import { utils, ResponseCode, Site } from "../../utils/Utils";
import { NavLink } from "react-router-dom";
import { AsyncAjaxDelete, AsyncAjaxGet, AsyncAjaxPatch, AsyncAjaxPost } from "../Common/AsyncAjaxService";
import VGPopUp from "../Controls/VGPopUp";
import Dropdown from "react-bootstrap/Dropdown";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import NoRights from "../Common/NoRights";
import Loader from "../Common/Loader";
import Alert from "react-bootstrap/Alert";
import { useSelector } from 'react-redux';
import $ from "jquery";
import DomainRenewPopup from './DomainRenewPopup';
import { useParams } from "react-router-dom";
import { useDispatch } from 'react-redux'
import useGenerateToken from "components/Hook/useGenerateToken";
import { Link } from "react-router-dom";
import { SuccessDeleteDomain } from "components/Slice/Business";
import useSession from "components/Hook/useSession";
import EditDNS from "./EditDNS";

const PurchasedDomain = (props) => {

     const { BusinessID, ReactBusinessId, ReactUserID, UserID, BuildInDomain, IsNewCustomWebSite, VagaroURL, WebsiteBuilderParentWebsite, IsViewAllowed, IsModifyAllowed } = useSelector((state) => state.Business);
     const dispatch = useDispatch();

     const { StyleId, LayoutId } = useParams();

     const VagaroAPIEnum = {
          GetPurchasedDomainList: "merchants/" + BusinessID + "/domains/purchased",
          StopRenewDomain: "merchants/" + BusinessID + "/domains/",
          StartRenewDomain: "merchants/" + BusinessID + "/domains/",
          DisconnectedDomain: "merchants/" + BusinessID + "/domains/",
          ConnectedDomain: "merchants/" + BusinessID + "/domains/",
          DomainAvailability: BusinessID + "/domains/",
          AddDomainInCart: "merchants/" + BusinessID + "/domains/carts",
          GetOwnerCardDetails: BusinessID + "/zenswipe/getownercarddetails",
          GetConnectionData: "merchants/" + BusinessID + "/domains/connectiondataruntime",
          GetDomainProvider: BusinessID + "/domains/domainproviders",
          RemoveDomian: "merchants/" + BusinessID + "/domains/removedomainname",
          ValidateDomain: BusinessID + "/websitebuilders/validatedomain",
          ConnectionDNS: "merchants/" + BusinessID + "/domainssl/connectionDNS",
          ResetDNS: "merchants/" + BusinessID + "/domainssl/resetDNS",
          SaveDNS: "merchants/" + BusinessID + "/domainssl/saveDNS",
          SetPrimaryDomain: "merchants/" + BusinessID + "/domains/setprimarydomain",
          RemovePrimaryDomain: "merchants/" + BusinessID + "/domains/removeprimarydomain"
     };

     const [isLoading, setLoading] = useState(false);
     const [customDomainList, setCustomDomainList] = useState([]);
     const CustomDomain = useRef([]);
     const [IsMessageOpen, setIsMessageOpen] = useState(false);
     const [Message, setMessage] = useState("");
     const [connectiondata, setConnectionData] = useState([]);
     const [selectedDomain, setSelectedDomain] = useState([]);

     const cardTokenDetails = useRef([]);

     const domainSearchResultHeight = (e) => {

          var wHeight = $(window).height();
          var titleHeight
          if ($(".domain-section-title").length) {
               titleHeight = $(".domain-section-title").outerHeight(true);
          } else {
               titleHeight = 0;
          }

          var tabHeight
          if ($(".domain-section-title").length) {
               tabHeight = $(".domain-section-title").outerHeight(true);
          } else {
               tabHeight = 0;
          }
          var actionbtn
          if ($(".domain-actions").length) {
               actionbtn = $(".domain-actions").outerHeight(true);

          } else {
               actionbtn = 0;
          }

          var builindomain
          if ($(".jsbuiltin-domains").length) {
               builindomain = $(".jsbuiltin-domains").outerHeight(true);

          } else {
               builindomain = 0;
          }


          var calCardWrapperHeight = wHeight - titleHeight - tabHeight - actionbtn - builindomain - 100;
          $(".purchasedDomainslist").css("max-height", calCardWrapperHeight);

     }

     const GetConnectionData = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetConnectionData,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        setConnectionData(data.data.data);
                                        setLoading(false);
                                        var contorys = $(".copied-text-blue");
                                        if (contorys.length > 0) {
                                             $.grep(contorys, (ele) => {
                                                  ele.classList.remove("copied-text-blue");
                                             })
                                        }

                                        //code here
                                        if (CustomDomain.current.length > 0) {
                                             var ConnectionsData = data.data.data;
                                             var ConnectionInProgress = CustomDomain.current.filter(
                                                  (col) => col.domainStatus.toLowerCase() == "connectioninprogress" && col.isPurchased == false
                                             );
                                             if (ConnectionInProgress.length > 0) {
                                                  ConnectionInProgress.map((custom) => {
                                                       var IsAnyConnectionInProgress = ConnectionsData.filter(
                                                            (col) => col.domainName.toLowerCase() == custom.domainName.toLowerCase() && col.status == false
                                                       );
                                                       if (IsAnyConnectionInProgress.length > 0) {
                                                            var FilterDomainData = CustomDomain.current.filter(
                                                                 (col) => col.domainName === custom.domainName
                                                            );
                                                            if (FilterDomainData.length > 0) {
                                                                 FilterDomainData[0].status = "Connections Pending";
                                                                 FilterDomainData[0].message = "Connect DNS Settings (use the information below to connect your domain)";
                                                                 CustomDomain.current.map((d, i) => {
                                                                      if (d.domainName.toLowerCase() === FilterDomainData[0].domainName.toLowerCase()) {
                                                                           CustomDomain.current[i] = FilterDomainData[0];
                                                                      }
                                                                 });
                                                                 //setCustomDomainList(CustomDomain.current);
                                                            }
                                                       }
                                                  });
                                             }
                                        }
                                   }
                                   else {
                                        setConnectionData([]);
                                        setLoading(false);
                                   }
                              }
                              setCustomDomainList(CustomDomain.current);
                              setLoading(false);
                              $("#forautofocus").focus();
                              domainSearchResultHeight();
                         }
                         catch (error) {
                              setCustomDomainList(CustomDomain.current);
                              setLoading(false);
                              $("#forautofocus").focus();
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Collection Data",
                                   BusinessID,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setCustomDomainList(CustomDomain.current);
                         setLoading(false);
                         $("#forautofocus").focus();
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Collection Data",
                              BusinessID,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     };

     const copyToClipboard = (d) => {
          var contorys = $(".copied-text-blue");
          if (contorys.length > 0) {
               $.grep(contorys, (ele) => {
                    ele.classList.remove("copied-text-blue");
               })
          }
          if (d !== "") {
               navigator.clipboard.writeText(d)
          }
     }

     const CheckSession = async () => {
          setLoading(true);
          return await useSession(dispatch, BusinessID, UserID, (data) => {
               setLoading(false);
               if (data == true) {
                    utils.SetPageTitle("Purchased Domain");
                    if (ReactBusinessId > 0) {
                         PurchasedDomainList();
                         domainSearchResultHeight();
                         window.addEventListener('resize', domainSearchResultHeight);
                    }
                    CheckLogin();
               }
          });
     }

     useEffect(() => {
          CheckSession();
     }, [BusinessID]);

     useEffect(() => {
          if (IsMessageOpen) {
               window.setTimeout(() => {
                    setIsMessageOpen(false);
               }, 3000)
          }
     }, [IsMessageOpen])

     const CheckLogin = () => {
          if (ReactBusinessId === -2) {
               window.location.replace(WebsiteBuilderParentWebsite + "login");
          }
     }

     const GetOwnerCard = async (domainName, expiredOn, amount) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxPost(
                    VagaroAPIEnum.GetOwnerCardDetails,
                    null,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        cardTokenDetails.current = data.data.data;
                                   }
                                   else {
                                        cardTokenDetails.current = [];
                                   }
                              }
                              else {
                                   cardTokenDetails.current = [];
                              }
                              setLoading(false);
                              return ReactDom.render(
                                   <DomainRenewPopup
                                        dispatch={dispatch}
                                        cardTokenDetails={cardTokenDetails}
                                        userID={UserID}
                                        businessID={BusinessID}
                                        reactBusinessId={ReactBusinessId}
                                        reactUserID={ReactUserID}
                                        domainName={domainName}
                                        expiredOn={expiredOn}
                                        amount={amount}
                                        PurchasedDomainList={PurchasedDomainList}
                                        setIsMessageOpen={setIsMessageOpen}
                                        setMessage={setMessage}
                                   />,
                                   document.getElementById("OpenDialog"))
                         }
                         catch (error) {
                              setLoading(false);
                              cardTokenDetails.current = [];
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Cart Domain List",
                                   null,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         cardTokenDetails.current = [];
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Cart Domain List",
                              null,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const PurchasedDomainList = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetPurchasedDomainList,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        CustomDomain.current = data.data.data;
                                        GetConnectionData();
                                        var UseAnotherDomain = CustomDomain.current.filter(
                                             (col) => col.isPurchased == false
                                        );
                                        if (UseAnotherDomain.length > 0) {
                                             GetDomainList(UseAnotherDomain);
                                        }
                                   }
                                   else {
                                        setCustomDomainList([]);
                                        CustomDomain.current = [];
                                   }
                              }
                              setLoading(false);

                              domainSearchResultHeight();
                         }
                         catch (error) {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Purchased Domain List",
                                   BusinessID,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Purchased Domain List",
                              BusinessID,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     };

     const PopupClose = () => {
          unmountComponentAtNode(document.getElementById("OpenDialog"));
     };

     const CancelAutoRenewPopup = (domainName, expiredOn) => {
          return ReactDom.render(
               <VGPopUp
                    id={"CancelAutoRenewPopup"}
                    show={true}
                    onHide={PopupClose}
                    title={"Cancel Auto Renew"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                         <div className="alertContent">
                              <p>Your domain <b>{domainName.toLowerCase()}</b> will not auto renew and will expire on <b>{expiredOn}</b>. Your domain can be bought by others and your website will only be accessible through {BuildInDomain}/{VagaroURL}.</p>
                         </div>
                    }
                    footer={
                         <Fragment>
                              <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Back</button>
                              <button className="w-button w-button-destructive-outline" onClick={() => CancelAutoRenew(domainName)}>Cancel Auto Renew</button>
                         </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
               />,
               document.getElementById("OpenDialog"));
     }

     const CancelAutoRenew = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to cancel auto renew domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.UserID = UserID;
                    await AsyncAjaxPatch(
                         VagaroAPIEnum.StopRenewDomain + domainName + "/autorenew/off",
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             PopupClose();
                                             PurchasedDomainList();
                                             setLoading(false);
                                             setIsMessageOpen(true);
                                             setMessage(domainName + " has been stop renewed successfully.");
                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                        utils.ShowAlert("Message", data.data.message, "OpenDialog");
                                   }
                              }
                              catch (error) {
                                   PopupClose();
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Cancel Auto Renew Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              PopupClose();
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Cancel Auto Renew Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }

                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     };

     const EnableAutoRenewPopup = (domainName, expiredOn, amount) => {
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to enable auto renew domain.", "OpenDialog");
          }
          else {
               if (cardTokenDetails.current.length == 0) {
                    GetOwnerCard(domainName, expiredOn, amount);
               }
               else {
                    return ReactDom.render(
                         <DomainRenewPopup
                              dispatch={dispatch}
                              cardTokenDetails={cardTokenDetails}
                              userID={UserID}
                              businessID={BusinessID}
                              reactBusinessId={ReactBusinessId}
                              reactUserID={ReactUserID}
                              domainName={domainName}
                              expiredOn={expiredOn}
                              amount={amount}
                              PurchasedDomainList={PurchasedDomainList}
                              setIsMessageOpen={setIsMessageOpen}
                              setMessage={setMessage}
                         />,
                         document.getElementById("OpenDialog"))
               }
          }
     }



     const DisconnectDomainPopup = (domainName) => {
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to disconnect domain.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"DisconnectDomainPopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Disconnect Domain"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>Your domain <b>{domainName.toLowerCase()}</b> will be disconnected from your Vagaro website, which will then only be accessible through {BuildInDomain}/{VagaroURL}.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Back</button>
                                   <button className="w-button w-button-destructive-outline" onClick={() => DisConnectDomain(domainName)}>Disconnect Domain</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }

     const DisConnectDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to disconnect domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.UserID = UserID;
                    await AsyncAjaxPatch(
                         VagaroAPIEnum.DisconnectedDomain + domainName + "/disconnect",
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             PopupClose();
                                             PurchasedDomainList();
                                             setLoading(false);
                                             setIsMessageOpen(true);
                                             setMessage(domainName + " has been successfully disconnected with dns.");
                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                        utils.ShowAlert("Message", data.data.message, "OpenDialog");
                                   }

                              }
                              catch (error) {
                                   PopupClose();
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Disconnect Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              PopupClose();
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Disconnect Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const ConnectDomainPopup = (domainName) => {
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to connect domain.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"ConnectDomainPopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Connect Domain"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>Your domain <b>{domainName.toLowerCase()}</b> will be connected to your Vagaro website.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Back</button>
                                   <button className="w-button w-button-primary" onClick={() => ConnectDomain(domainName)}>Connect Domain</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }

     const ConnectDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to connect domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.UserID = UserID;
                    await AsyncAjaxPatch(
                         VagaroAPIEnum.ConnectedDomain + domainName + "/connect",
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             PopupClose();
                                             PurchasedDomainList();
                                             setLoading(false);
                                             // setIsMessageOpen(true);
                                             // setMessage(domainName + " connection is in progress.");
                                        }
                                        else {
                                             PopupClose();
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        PopupClose();
                                        setLoading(false);
                                        utils.ShowAlert("Message", data.data.message, "OpenDialog");
                                   }

                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Connect Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              PopupClose();
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Connect Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const SetPrimaryDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to connect domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxPost(
                         VagaroAPIEnum.SetPrimaryDomain + "?DomainName=" + domainName,
                         "",
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data != null && data.data.status === 200) {
                                             PurchasedDomainList();
                                             setLoading(false);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                        utils.ShowAlert("Message", data.data.message, "OpenDialog");
                                   }

                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Set Primary Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Set Primary Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const RemovePrimaryDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to connect domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxDelete(
                         VagaroAPIEnum.RemovePrimaryDomain + "?DomainName=" + domainName,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data != null && data.data.status === 200) {
                                             PurchasedDomainList();
                                             setLoading(false);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                        utils.ShowAlert("Message", data.data.message, "OpenDialog");
                                   }

                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Set Primary Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Remove Primary Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const GoToDomainPage = (domainName) => {
          let a = document.createElement('a');
          a.target = '_self';
          a.href = "/business/" + StyleId + "/" + LayoutId + "/searchdomain/" + domainName;
          a.click();
     }

     const BuyNewDomainPopup = (domainName) => {
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to buy domain.", "OpenDialog");
          }
          else {
               return ReactDom.render(
                    <VGPopUp
                         id={"UnablePurchaseDomain"}
                         show={true}
                         onHide={PopupClose}
                         title={"Unable to Purchase Domain"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>Your domain has already been purchased by someone. Search for another domain to purchase.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Close</button>
                                   <button className="w-button w-button-primary" onClick={() => GoToDomainPage(domainName)}>Get a Domain</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
     }

     const AddtoCart = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to cancel add domain in cart.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    const Requestdata = {};
                    Requestdata.DomainName = domainName;
                    Requestdata.UserID = UserID;
                    setLoading(true);
                    await AsyncAjaxPost(
                         VagaroAPIEnum.AddDomainInCart,
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             let a = document.createElement('a');
                                             a.target = '_self';
                                             a.href = "/business/" + StyleId + "/" + LayoutId + "/checkout/" + domainName;
                                             a.click();
                                             setLoading(false);
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        let a = document.createElement('a');
                                        a.target = '_self';
                                        a.href = "/business/" + StyleId + "/" + LayoutId + "/checkout/" + domainName;
                                        a.click();
                                        setLoading(false);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Add to cart Domain List",
                                        null,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Add to cart Domain List",
                                   null,
                                   ""
                              );
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const BuyDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to cancel buy domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxGet(
                         VagaroAPIEnum.DomainAvailability + domainName + "/available",
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null) {
                                             if (data.data.data.available == true) {
                                                  AddtoCart(domainName);
                                             }
                                             else {
                                                  setLoading(false);
                                                  BuyNewDomainPopup(domainName);
                                             }
                                        }
                                        else {
                                             setLoading(false);
                                             BuyNewDomainPopup(domainName);
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                        BuyNewDomainPopup(domainName);
                                   }
                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Get Domain Availability",
                                        BusinessID,
                                        ""
                                   );
                                   utils.ShowAlert("Unable to Purchase Domain", "Your domain has already been purchased by someone. Search for another domain to purchase.", "OpenDialog");
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Domain Availability",
                                   BusinessID,
                                   ""
                              );
                              utils.ShowAlert("Unable to Purchase Domain", "Your domain has already been purchased by someone. Search for another domain to purchase.", "OpenDialog");
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const GetDomainList = async (UseAnotherDomain) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.GetDomainProvider,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        var DomainProviderList = data.data.data;
                                        if (DomainProviderList.length > 0 && UseAnotherDomain.length > 0) {
                                             let SelectedDomainList = []
                                             UseAnotherDomain.map((d) => {
                                                  var SelectedDomainProvider = DomainProviderList.filter(
                                                       (col) => col.domainName.toLowerCase() == d.serviceProvider.toLowerCase()
                                                  );
                                                  if (SelectedDomainProvider.length > 0) {
                                                       var IsNotExist = SelectedDomainList.filter(
                                                            (col) => col.domainName.toLowerCase() == d.serviceProvider.toLowerCase()
                                                       );
                                                       if (IsNotExist.length == 0) {
                                                            SelectedDomainList.push(SelectedDomainProvider[0]);
                                                       }
                                                  }
                                             })
                                             setSelectedDomain(SelectedDomainList);
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                   }
                              }
                              else {
                                   setLoading(false);
                              }

                         } catch (error) {
                              setLoading(false);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     };


     const RemoveDomain = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to Remove domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxDelete(
                         VagaroAPIEnum.RemoveDomian + "?DomainName=" + domainName,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             PurchasedDomainList();
                                             setLoading(false);
                                             setIsMessageOpen(true);
                                             ValidatePurcheshdDomain();
                                             setMessage(domainName + " has been successfully removed.");
                                        }
                                        else {
                                             setLoading(false);
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                        utils.ShowAlert("Message", data.data.message, "OpenDialog");
                                   }

                              }
                              catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Remove Domain",
                                        domainName,
                                        ""
                                   );
                              }
                         },
                         function OnError(error) {
                              setLoading(false);
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Remove Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                                   utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }
     const ValidatePurcheshdDomain = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               await AsyncAjaxGet(
                    VagaroAPIEnum.ValidateDomain,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null && data.data.data === false) {
                                        dispatch(SuccessDeleteDomain());
                                   }
                              }
                              else {
                                   utils.ShowAlert("Message", data.data.message, "OpenDialog");
                              }

                         }
                         catch (error) {
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Validate Domain",
                                   "",
                                   ""
                              );
                         }
                    },
                    function OnError(error) {
                         if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Validate Domain : " + error.response.data.errors.exception,
                                   "",
                                   ""
                              );
                              utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                         }
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }


     const GoToVagaroPage = async () => {
          let a = document.createElement('a');
          a.target = '_blank';
          a.href = Site.SiteName + VagaroURL;
          a.click();
     }

     const OpenPopup = async (IsMySite, DomainName) => {
          if (!IsNewCustomWebSite) {
               return ReactDom.render(
                    <VGPopUp
                         id={"ClosePopup"}
                         show={true}
                         onHide={PopupClose}
                         title={"Go To Webiste"}
                         dialogClassName="cancelauto-renew-alert"
                         body={
                              <div className="alertContent">
                                   <p>Website builder is not published.</p>
                              </div>
                         }
                         footer={
                              <Fragment>
                                   <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Close</button>
                                   <button className="w-button w-button-primary" onClick={() => GoToVagaroPage()}>Get Vagaro Page</button>
                              </Fragment >
                         }
                         isRemoveTabModalIndex={false}
                         isShowFooter={true}
                         size={"md"}
                         backdrop={true}
                    />,
                    document.getElementById("OpenDialog"));
          }
          else {
               if (IsMySite) {
                    let a = document.createElement('a');
                    a.target = '_blank';
                    a.href = "https://" + BuildInDomain + "/" + VagaroURL;
                    a.click();
               }
               else {
                    let a = document.createElement('a');
                    a.target = '_blank';
                    a.href = "https://www." + DomainName
                    a.click();
               }
          }
     }

     const NavigateToDNSTable = () => {
          window.location.href = `${'/business/' + StyleId + "/" + LayoutId + "/usedomain"}`
     }

     const SaveDNSProcess = async (saveDNS, domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxPost(
                    VagaroAPIEnum.SaveDNS,
                    saveDNS,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null && data.data.data == true) {
                                        ConnectionDNSRecords(domainName);
                                   }
                              }
                              setLoading(false);

                         }
                         catch (error) {
                              setLoading(false);
                              cardTokenDetails.current = [];
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Save DNS",
                                   null,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         cardTokenDetails.current = [];
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Save DNS",
                              null,
                              ""
                         );
                         utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const ResetDefaultDNS = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to Edit DNS Records.", "OpenDialog1");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxGet(
                         VagaroAPIEnum.ResetDNS + "/" + domainName,
                         access_token,
                         function onSuccess(data) {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        setLoading(false);
                                        ConnectionDNSRecords(domainName);
                                   }
                              }
                              else {
                                   setLoading(false);
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              cardTokenDetails.current = [];
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Reset DNS Records",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog1", true);
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog1", true);
               }
          }
     }


     const ConnectionDNSRecords = async (domainName) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to Edit DNS Records.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxGet(
                         VagaroAPIEnum.ConnectionDNS + "/" + domainName,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null) {
                                             var response = data.data.data;
                                             response.map((data, index) => {
                                                  data.isAdded = true;
                                                  data.rank = index + 1;
                                                  data.ischanges = false;
                                             });
                                             setLoading(false);
                                             unmountComponentAtNode(document.getElementById("OpenDialog"));
                                             return ReactDom.render(
                                                  <EditDNS
                                                       domainName={domainName}
                                                       response={response}
                                                       isModifyAllowed={IsModifyAllowed}
                                                       resetDefaultDNS={ResetDefaultDNS}
                                                       reactBusinessId={ReactBusinessId}
                                                       saveDNSProcess={SaveDNSProcess}
                                                       reactUserID={ReactUserID}
                                                  />,
                                                  document.getElementById("OpenDialog"))
                                        }
                                   }
                                   setLoading(false);
                              }
                              catch (error) {
                                   setLoading(false);
                                   cardTokenDetails.current = [];
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "DNS Binding",
                                        null,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              cardTokenDetails.current = [];
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "DNS Binding",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     return (
          <div className={ReactBusinessId <= 0 ? "all-content-container no-access-main-content-wrapper" : "all-content-container main-content-wrapper"}>
               {!props.inEditor && <Leftpanel
                    activateTab={"GeneralSetting"}
                    activatePage={"Domain"}
               />}

               {(() => {
                    if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                         return (
                              <Fragment>
                                   <NoRights />
                              </Fragment>
                         )
                    } else {
                         return (
                              <Fragment>
                                   <div className="page-root">
                                        {isLoading && <Loader />}
                                        <div className="page-content container">
                                             {IsMessageOpen &&
                                                  <Alert isOpen={IsMessageOpen} variant="success" className="vg-alert-strip vg-passive">
                                                       <i class="fas fa-check-circle"></i> {Message}
                                                  </Alert>
                                             }
                                             <div className="usedomain-wrapper">
                                                  <div className="domain-section-title py-t16">
                                                       Domains
                                                  </div>
                                                  <div className="domain-actions">
                                                       {!props.inEditor ?
                                                            <NavLink
                                                                 to={{ pathname: `${'/business/' + StyleId + "/" + LayoutId + "/searchdomain"}` }}
                                                                 className="w-button w-button-neutral"
                                                            >
                                                                 Get a Domain
                                                            </NavLink>
                                                            :
                                                            <div
                                                                 onClick={() => {
                                                                      props.setMenu && props.setMenu(3)
                                                                 }}
                                                                 className="w-button w-button-neutral"
                                                            >
                                                                 Get a Domain
                                                            </div>

                                                       }


                                                       {!props.inEditor ?
                                                            <NavLink
                                                                 to={{ pathname: `${'/business/' + StyleId + "/" + LayoutId + "/usedomain"}` }}
                                                                 className="w-button w-button-secondary"
                                                            >
                                                                 Use a Domain I Own
                                                            </NavLink>
                                                            :
                                                            <div
                                                                 onClick={() => {
                                                                      props.setMenu && props.setMenu(4)
                                                                 }}
                                                                 className="w-button w-button-secondary"
                                                            >
                                                                 Use a Domain I Own
                                                            </div>
                                                       }
                                                  </div>
                                                  {customDomainList.length > 0 &&
                                                       <Fragment>
                                                            <div className="domain-section-title">
                                                                 Custom Domain
                                                            </div>
                                                            <div className={`builtin-domains`}>
                                                                 {customDomainList.length > 0 && customDomainList.map((d) => {
                                                                      return (
                                                                           <div className="builtin-domain">
                                                                                <div className="domain-details" onClick={() => d.isPurchased === true ? "" : NavigateToDNSTable()}>
                                                                                     <div className="domain-name">
                                                                                          <a onClick={(e) => { e.stopPropagation(); e.preventDefault(); (d.isConnected === true) && OpenPopup(false, d.domainName); }} target="_blank" rel="noreferrer">
                                                                                               {d.domainName}{" "}
                                                                                               {d.isConnected === true &&
                                                                                                    <i className="far fa-external-link link-icon"></i>
                                                                                               }
                                                                                          </a>
                                                                                     </div>
                                                                                     <span className={d.status.toLowerCase() === "expired" || d.status.toLowerCase() === "stopped renew" || d.status.toLowerCase() === "connections pending" ? "domain-expiry expringsoon" : "domain-expiry"}>
                                                                                          {d.message === "Connection in progress" ? "Connection in Progress (may take 24-48 hours)" : d.message}
                                                                                     </span>
                                                                                </div>
                                                                                {d.isPurchased && d.isExpired == true ?
                                                                                     <div className="domain-more">
                                                                                          <Dropdown className="moremenu dropdown">
                                                                                               <Dropdown.Toggle className="more-3dot">
                                                                                                    {IsModifyAllowed ?
                                                                                                         <i
                                                                                                              className="far fa-ellipsis-v"
                                                                                                              aria-hidden="true"
                                                                                                         />
                                                                                                         : <i
                                                                                                              className="far fa-ellipsis-v"
                                                                                                              aria-hidden="true"
                                                                                                              onClick={(e) => {
                                                                                                                   utils.ShowAlert("Alert", "You do not have access to modify.", "OpenDialog", true);
                                                                                                              }}
                                                                                                         />}
                                                                                               </Dropdown.Toggle>
                                                                                               {IsModifyAllowed &&
                                                                                                    <Dropdown.Menu align="end">
                                                                                                         <Dropdown.Item onClick={(e) => { BuyDomain(d.domainName) }}>
                                                                                                              Buy Domain
                                                                                                         </Dropdown.Item>
                                                                                                         <Dropdown.Item onClick={(e) => { RemoveDomain(d.domainName) }}>
                                                                                                              Remove Domain
                                                                                                         </Dropdown.Item>
                                                                                                    </Dropdown.Menu>
                                                                                               }
                                                                                          </Dropdown>
                                                                                     </div> :
                                                                                     <div className="domain-more">
                                                                                          {
                                                                                               ((d.isPurchased && d.isAutoRenew === true) || (d.isPurchased && d.isAutoRenew === false) || (d.isConnected === true) ||
                                                                                                    (d.isConnected === false) || (d.isPurchased && d.isConnected === true)) &&
                                                                                               <Dropdown className="moremenu dropdown">
                                                                                                    <Dropdown.Toggle className="more-3dot">
                                                                                                         {IsModifyAllowed ?
                                                                                                              <i
                                                                                                                   className="far fa-ellipsis-v"
                                                                                                                   aria-hidden="true"
                                                                                                              />
                                                                                                              : <i
                                                                                                                   className="far fa-ellipsis-v"
                                                                                                                   aria-hidden="true"
                                                                                                                   onClick={(e) => {
                                                                                                                        utils.ShowAlert("Alert", "You do not have access to modify.", "OpenDialog", true);
                                                                                                                   }}
                                                                                                              />}
                                                                                                    </Dropdown.Toggle>
                                                                                                    {IsModifyAllowed &&
                                                                                                         <Dropdown.Menu align="end">
                                                                                                              {d.isPurchased && d.isAutoRenew === true &&
                                                                                                                   <Dropdown.Item onClick={(e) => { CancelAutoRenewPopup(d.domainName, d.expiredOn) }}>
                                                                                                                        Cancel Auto Renew
                                                                                                                   </Dropdown.Item>
                                                                                                              }

                                                                                                              {d.isPurchased && d.isAutoRenew === false &&
                                                                                                                   <Dropdown.Item onClick={(e) => { EnableAutoRenewPopup(d.domainName, d.expiredOn, d.amount) }}>
                                                                                                                        Enable Auto Renew
                                                                                                                   </Dropdown.Item>
                                                                                                              }

                                                                                                              {d.isConnected === true &&
                                                                                                                   <Dropdown.Item onClick={(e) => { DisconnectDomainPopup(d.domainName, d.isPurchased) }}>
                                                                                                                        Disconnect Domain
                                                                                                                   </Dropdown.Item>
                                                                                                              }

                                                                                                              {d.isConnected === true && d.isPrimaryDomain === false &&
                                                                                                                   <Dropdown.Item onClick={(e) => { SetPrimaryDomain(d.domainName) }}>
                                                                                                                        Set Primary Domain
                                                                                                                   </Dropdown.Item>
                                                                                                              }
                                                                                                              
                                                                                                              {d.isConnected === true && d.isPrimaryDomain === true &&
                                                                                                                   <Dropdown.Item onClick={(e) => { RemovePrimaryDomain(d.domainName) }}>
                                                                                                                        Remove Primary Domain
                                                                                                                   </Dropdown.Item>
                                                                                                              }

                                                                                                              {d.isConnected === false && d.domainStatus.toLowerCase() != "connectioninprogress" &&
                                                                                                                   <Dropdown.Item onClick={(e) => { ConnectDomainPopup(d.domainName, d.isPurchased) }}>
                                                                                                                        Connect Domain
                                                                                                                   </Dropdown.Item>
                                                                                                              }
                                                                                                              {d.isConnected === false && !d.isPurchased &&
                                                                                                                   <Dropdown.Item onClick={(e) => { RemoveDomain(d.domainName) }}>
                                                                                                                        Remove Domain
                                                                                                                   </Dropdown.Item>
                                                                                                              }
                                                                                                              {d.isConnected === true && d.isPurchased &&
                                                                                                                   <Dropdown.Item onClick={(e) => { ConnectionDNSRecords(d.domainName) }}>
                                                                                                                        Edit DNS Record
                                                                                                                   </Dropdown.Item>
                                                                                                              }
                                                                                                         </Dropdown.Menu>
                                                                                                    }
                                                                                               </Dropdown>
                                                                                          }
                                                                                     </div>
                                                                                }
                                                                           </div>
                                                                      )
                                                                 })}
                                                            </div>
                                                       </Fragment>
                                                  }
                                                  <div className="domain-section-title">
                                                       Built In Domain
                                                  </div>
                                                  <div className="builtin-domains jsbuiltin-domains">
                                                       <div className="builtin-domain">
                                                            <div className="domain-details">
                                                                 <div className="domain-name">
                                                                      <a onClick={() => OpenPopup(true, "")} target="_blank" rel="noreferrer" >
                                                                           {BuildInDomain}/{VagaroURL}{" "}
                                                                           <i className="far fa-external-link link-icon"></i>
                                                                      </a>
                                                                 </div>
                                                                 <span className="domain-expiry">
                                                                      Never Expires
                                                                 </span>
                                                            </div>
                                                       </div>
                                                  </div>
                                                  {connectiondata.length > 0 &&
                                                       <Fragment>
                                                            <Fragment>
                                                                 <br></br>
                                                                 <div className="domain-section-title">
                                                                      DNS Settings to Connect Your Domain
                                                                 </div>
                                                                 <div className="domain-section-body"><span>Update your domain provider settings to match the following information.</span><span className="refresh-list-icon" onClick={() => GetConnectionData()}><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z" /></svg></span></div>
                                                                 <div className="vg-table-wrapper py-t8 py-b24 tablscrollbdr">
                                                                      <div className="vg-table-bdr">
                                                                           <table className="table">
                                                                                <thead>
                                                                                     <tr>
                                                                                          <th>Domain</th>
                                                                                          <th>Type</th>
                                                                                          <th>Host</th>
                                                                                          <th>Required Value</th>
                                                                                          <th>Connection</th>
                                                                                     </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                     {connectiondata.length > 0 && connectiondata.map((d) => {
                                                                                          return (
                                                                                               <Fragment>
                                                                                                    <tr>
                                                                                                         <td data-lbl="Domain">{d.domainName}</td>
                                                                                                         <td data-lbl="Type">{d.recordType}</td>
                                                                                                         <td data-lbl="Host">{d.recordName}</td>
                                                                                                         <td className="word-break-td" data-lbl="Required Value">{d.recordValue == "Gathering information. It may take up to few minutes." ? <Fragment><span className="text-disconnected">Gathering information. It may take up to few minutes.</span></Fragment> : <Fragment>{d.recordValue} {d.recordValue !== "" && <div className="copytoclipboard icons" onClick={(e) => { copyToClipboard(d.recordValue); e.target.classList.add("copied-text-blue") }}><div ><i class="fal fa-copy"></i></div></div>}</Fragment>}</td>
                                                                                                         <td data-lbl="Connection">{d.status == true && <span className="text-connected">Connected</span>}
                                                                                                              {d.status == false && <span className="text-disconnected">Disconnected</span>}</td>
                                                                                                    </tr>
                                                                                               </Fragment>
                                                                                          )
                                                                                     })}
                                                                                </tbody>
                                                                           </table>
                                                                      </div>
                                                                 </div>
                                                            </Fragment>
                                                            {selectedDomain.length > 0 &&
                                                                 <Fragment>
                                                                      <div className="domain-info">
                                                                           <div className="domain-section-title">To Connect Domain</div>
                                                                           <p>
                                                                                Check the requirements from your domain
                                                                                provider{", "}
                                                                                {
                                                                                     selectedDomain.length > 0 && selectedDomain.map((d) => {
                                                                                          return (
                                                                                               d.domainName != "Other" &&
                                                                                               <Fragment>
                                                                                                    <Link target="_blank" to={d.domainUrl}>{d.domainName}</Link>{", "}
                                                                                               </Fragment>
                                                                                          )
                                                                                     })
                                                                                }
                                                                                to
                                                                                use your domain.{" "}
                                                                           </p>
                                                                      </div>
                                                                 </Fragment>
                                                            }
                                                       </Fragment>
                                                  }
                                             </div>
                                        </div>
                                   </div>
                              </Fragment>
                         )
                    }
               })()}

          </div >
     );
};
export default withAITracking(reactPlugin, PurchasedDomain);
